import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from '../Univ.js';
function AccountsReceivable() {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [data, setData] = useState([]);
    const fetchReceivable = () => {
        const start = startDate
            ? startDate.toISOString().substring(0, 10)
            : '';
        const end = endDate
            ? endDate.toISOString().substring(0, 10)
            : '';
        axios.get(
            `${baseUrl}accounts-receivable/?start=${start}&end=${end}`
        )
            .then(res => {
                setData(res.data);
            })
            .catch(err => console.log(err));
    };
    useEffect(() => {
        fetchReceivable();
    }, [startDate, endDate]);
    const columns = [
        {
            field: 'date',
            headerName: 'Date',
            width: 130
        },
        {
            field: 'patient',
            headerName: 'Patient',
            width: 250
        },
        {
            field: 'bill_no',
            headerName: 'Bill No',
            width: 150
        },
        {
            field: 'module',
            headerName: 'Module',
            width: 180
        },
        {
            field: 'amount',
            headerName: 'Outstanding',
            width: 150
        },
    ];
    return (
        <section className='container mt-4'>

            <h3 className='bg-warning text-dark text-center p-2'>
                Accounts Receivable
            </h3>


            <div className="row mb-3">

                <div className="col-md-3">

                    <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        placeholderText="From Date"
                        className="form-control"
                    />

                </div>


                <div className="col-md-3">

                    <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        placeholderText="To Date"
                        className="form-control"
                    />

                </div>

            </div>


            <div style={{height: "100%", width: "100%"}}>

                <DataGrid
                    className="mt-2"

                    sx={{
                        boxShadow: 4,
                        border: 3,
                        borderColor: 'warning.light',
                        '& .MuiDataGrid-cell:hover': {
                            color: 'warning.main',
                        },
                    }}

                    rows={data}
                    columns={columns}
                    pageSize={10}
                    autoHeight

                    slots={{
                        toolbar: GridToolbar,
                    }}
                />

            </div>

        </section>
    )
}
export default AccountsReceivable;